module.exports = __webpack_public_path__ + "img/wingDRiderLogo@1x.4287fa53.webp";